<canvas baseChart
        class="chart"
        [data]="chartData"
        [type]="type"
        [options]="chartOptions"
></canvas>
